import React, { useState } from "react";
import Images from "assets/images";
import { Icon } from "stories/Icons";
import { BASE_API_URL } from "api/config";
import constants from "helpers/constants";
import { useCurrentUser } from "hooks/useCurrentUser";
import useToastify from "hooks/useToastify";
import "./GoogleReviewPopup.scss";

const GoogleReviewPopup = ({ isVisible, onClose }) => {
  const [isClosing, setIsClosing] = useState(false);
  const { userToken } = useCurrentUser();
  const { showAlert } = useToastify();

  const handleRateOnGoogle = async () => {
    try {
      const directResponse = await fetch(`${BASE_API_URL}api/v3/accounts/update-rating-flag.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Access-Token': userToken,
          'Device-Platform': 'Web'
        },
        body: JSON.stringify({ has_rated_on_google: true })
      });
      const response = await directResponse.json();
    
      if (response?.status === true) {
        window.open(constants.GOOGLE_APP_URL, "_blank");
      } else {
        showAlert(
          response?.message || "Something went wrong.", 
          "error"
        );
      }
    } catch (error) {
      console.log("Catch block error:", error);
      showAlert(error?.message || "Something went wrong.", "error");
    }
  };

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <div className="google-review-popup-overlay">
      <div className={`google-review-popup-container ${isClosing ? 'closing' : ''}`}>
        <div className="google-review-popup-content">
          <span className="google-review-popup-close" onClick={handleClose}>
            <img src={Images.closeIcon} alt="close" className="w-6 h-6" />
          </span>
          
          <h3 className="google-review-popup-title">Thanks for your 5-star rating!</h3>
          
          <div className="google-review-popup-stars">
            {Array.from({length: 5}).map((_, index) => (
              <img
                key={index}
                src={Images.starFilled}
                className="google-review-popup-star"
                alt="rating"
              />
            ))}
          </div>
          
          <p className="google-review-popup-subtitle">We appreciate your support!</p> 
          <p className="google-review-popup-subtitle">Spread the word by telling others about your experience.</p>
          
          <div className="google-review-popup-actions">
            <button
              className="google-review-popup-button"
              type="button"
              onClick={() => {
                handleRateOnGoogle();
                handleClose();
              }}
            >
              <div className="google-review-popup-button-content">
                <Icon name={"google"} className="google-review-popup-google-icon" /> 
                <span>Review on Google</span>
              </div>
            </button>
          </div>
          
          <p className="google-review-popup-later" onClick={handleClose}>
            Maybe later
          </p>
        </div>
      </div>
    </div>
  );
};

export default GoogleReviewPopup;
